import React from 'react';
import PaymentReportFunctional from './components/payment-report-list-functional';
import './payment-report.scss';

const PaymentReport = () => {
	return <PaymentReportFunctional />;
};

export default PaymentReport;
